export default "__VITE_ASSET__DAOupOwX__"